import {useDimensions} from '../../../../contexts/dimensions/use-dimensions'
import * as Styles from './_styles/nav-bar-link.styled'

import type {JSX} from 'react'

interface NavBarLinkProps {
    id: string
    path: string
    navLinkText: string
    showIndicator?: boolean
}

export function NavBarLink({id, path, navLinkText, showIndicator}: NavBarLinkProps): JSX.Element {
    const {width} = useDimensions()

    return (
        <Styles.NavigationLink
            id={id}
            to={path}
            width={width}
            className={({isActive}) => (isActive ? 'activeLink' : '')}
        >
            {navLinkText}
            {showIndicator && <Styles.IndicatorDot />}
        </Styles.NavigationLink>
    )
}
